import { WidgetUIType } from './widget.type';

export class WidgetModel {
  constructor(
    public widgetUIType: WidgetUIType,
    public selecedViewId: string
  ) {}
}

export class WidgetSettings {
  selectedViewId?: string;
}

export class WidgetInstanceModel {
  // Null until the instance has been persisted (virtual defaults have no id yet).
  id: string | null = null;
  widgetUIType: WidgetUIType;
  rank: number;
  settings: WidgetSettings = {};

  constructor(init?: Partial<WidgetInstanceModel>) {
    Object.assign(this, init);
  }
}
